import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { ApplicationService } from '../../../common/services/application.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { SubmitApplicationReview } from '../../../common/models/application';
import { StorageService } from '../../../common/services/storage.service';
import { CurrentUser } from '../../../common/models/user';

import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { CustomizerSettingsService } from '../../../customizer-settings/customizer-settings.service';
import { MatCardModule } from '@angular/material/card';
import { Subject, takeUntil } from 'rxjs';

@Component({
    selector: 'app-review',
    templateUrl: './review.component.html',
    styleUrls: ['./review.component.scss'],
    imports: [
    MatFormFieldModule,
    MatCardModule,
    MatInputModule,
    MatButtonModule,
    ReactiveFormsModule,
    FormsModule
]
})
export class ReviewComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  
  reviewForm: FormGroup;
  applicationId!: string;
  user: CurrentUser | null = null;

  isToggled = false;

  private readonly snackbarConfig: MatSnackBarConfig = {
      duration: 3000,
      horizontalPosition: 'right',
      verticalPosition: 'top'
  };
  

  constructor(
    public themeService: CustomizerSettingsService,
    private fb: FormBuilder,
    private applicationService: ApplicationService,
    private storageService: StorageService,
    private route: ActivatedRoute,
    private snackBar: MatSnackBar,
    private router: Router
  ) {
    this.reviewForm = this.fb.group({
      strategicGoalAchievementScore: [null, [Validators.required, Validators.min(1), Validators.max(5)]],
      activityClarityAndFeasibilityScore: [null, [Validators.required, Validators.min(1), Validators.max(5)]],
      localNeedsAlignmentScore: [null, [Validators.required, Validators.min(1), Validators.max(5)]],
      communityLifeEnhancementScore: [null, [Validators.required, Validators.min(1), Validators.max(5)]],
      participantDefinitionScore: [null, [Validators.required, Validators.min(1), Validators.max(5)]],
      managementAndExpertiseScore: [null, [Validators.required, Validators.min(1), Validators.max(5)]],
      costRealismScore: [null, [Validators.required, Validators.min(1), Validators.max(5)]],
      budgetItemLinkageScore: [null, [Validators.required, Validators.min(1), Validators.max(5)]],
      communityInvolvementScore: [null, [Validators.required, Validators.min(1), Validators.max(5)]],
      publicCommunicationAndPromotionScore: [null, [Validators.required, Validators.min(1), Validators.max(5)]],
      comments: [null, Validators.required]
    });
  }

  ngOnInit(): void {
    this.themeService.isToggled$.pipe(takeUntil(this.destroy$)).subscribe(isToggled => {
        this.isToggled = isToggled;
      });
  

    this.storageService.user$.pipe(takeUntil(this.destroy$)).subscribe(user => {
        this.user = user;
      });

    this.route.paramMap.pipe(takeUntil(this.destroy$)).subscribe(params => {
      this.applicationId = params.get('applicationId') || '';
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  submitReview(): void {
    if (this.reviewForm.invalid) {
      return;
    }

    const review: SubmitApplicationReview = {
      applicationId: this.applicationId,
      evaluatorId: this.user!.id,
      ...this.reviewForm.value
    };

    this.applicationService.review(review).pipe(takeUntil(this.destroy$)).subscribe({
      next: () => {
        this.snackBar.open('Obrazac ocjenjivanja (B3) uspješno podnesen', 'Zatvori', this.snackbarConfig);
        this.router.navigate(['/municipality/applications']);
      },
      error: (error) => {
        this.snackBar.open('Greška prilikom ispunjavanja obrasca ocjenjivanja (B3)', 'Zatvori', this.snackbarConfig);
        console.error(error);
      }
    });
  }
}